import React from 'react';
import Navbar from '../components/Layout/Navbar';
import Footerpage from '../components/Layout/Footer';
import { LiveJourney } from '../components/Sections/Sections';
import '../components/Sections/Sections.css';

const Events = () => {
  return (
    <div className="events-page">
      <Navbar />
      <div className="pt-12">
        <LiveJourney />
      </div>
      <Footerpage />
    </div>
  );
};

export default Events;
